module.exports = __webpack_public_path__ + "img/mycar.b4e81a67.png";